import React from 'react';
import {
  func, string, arrayOf, number
} from 'prop-types';
import { Translate } from 'react-localize-redux';
import { surveySchemaLinkType } from '../../../../constants/types';
import { getTranslation } from '../../../../i18n';
import styles from './connectedSurveySchemas.module.css';

const ConnectedSurveySchemas = ({
  surveySchemaLinks,
  selectedSurveySchemas,
  onSelect,
  currentLanguage
}) => {
  const getStatus = (schema) => {
    const statusText = (
      <p>
        <Translate id={schema.lockedFromEditing
          ? 'status.IN_USE' : `status.${schema.status}`}
        />
      </p>
    );
    const statusIconClassName = schema.lockedFromEditing
      ? 'icon--permission-private' : 'icon--edit-event';

    return (
      <div className={styles.status}>
        {statusText}
        <span className={`${styles.statusIcon} ${statusIconClassName}`} />
      </div>
    );
  };

  const renderSchemaRow = (schema, selectable) => (
    <tr key={schema.id} className={styles.row}>
      {selectable && (
      <td className={styles.selectCell}>
        <input type="checkbox" value={schema.id} checked={selectedSurveySchemas.includes(schema.id)} onChange={onSelect} />
      </td>
      )}
      <td>{getTranslation(schema.title, currentLanguage)}</td>
      <td>{schema.code}</td>
      <td className={styles.statusCell}>{getStatus(schema)}</td>
    </tr>
  );

  const schemaToShowFilter = (schemaLink, inUse) => {
    if (inUse) {
      return schemaLink.lockedFromEditing && schemaLink.latestVersion;
    }
    return !schemaLink.lockedFromEditing;
  };

  const renderSchemaTable = (schemas, inUse) => (
    <table className={styles.listing}>
      <thead className={styles.header}>
        <tr>
          {inUse && <th />}
          <th><Translate id="common.name" /></th>
          <th><Translate id="editor.identifier" /></th>
          <th><Translate id="common.status" /></th>
        </tr>
      </thead>
      <tbody>
        {schemas
          .filter((ss) => schemaToShowFilter(ss, inUse))
          .map((ss) => renderSchemaRow(ss, inUse))}
      </tbody>
    </table>
  );

  return (
    <div className={styles.container}>
      {surveySchemaLinks.some((ssl) => schemaToShowFilter(ssl, false))
      && (
      <div>
        <p><Translate id="editor.surveySchemaPartPreview.connectedSchemaNotInUseExplanation" /></p>
        {renderSchemaTable(surveySchemaLinks, false)}
      </div>
      )}
      {surveySchemaLinks.some((ssl) => schemaToShowFilter(ssl, true))
      && (
      <div>
        <p><Translate id="editor.surveySchemaPartPreview.connectedSchemaInUseExplanation" /></p>
        {renderSchemaTable(surveySchemaLinks, true)}
      </div>
      )}
    </div>
  );
};

ConnectedSurveySchemas.propTypes = {
  surveySchemaLinks: arrayOf(surveySchemaLinkType).isRequired,
  selectedSurveySchemas: arrayOf(number).isRequired,
  onSelect: func.isRequired,
  currentLanguage: string.isRequired
};

export default ConnectedSurveySchemas;
